import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  row-gap: 10px;
  column-gap: 6px;
  padding-top: 15px;
`;
